import { LabelDisplayedRowsArgs, TablePagination } from '@material-ui/core';
import { stringToNumber } from 'annotation-tools/utils';
import React, { memo, useCallback } from 'react';
import { rowsPerPageOptions } from '../../../constants/rows-per-page-options';
import { viewTexts } from '../../../constants/view-texts';

const vt = viewTexts.table.pagination;

interface Props {
  numRows: number;
  page: number;
  onChangePage: (page: number) => void;
  rowsPerPage: number;
  onChangeRowsPerPage: (rowsPerPage: number) => void;
}

const nextIconButtonProps = { title: vt.nextPageTooltip };
const backIconButtonProps = { title: vt.prevPageTooltip };

const labelDisplayedRows = ({
  from,
  to,
  count
}: LabelDisplayedRowsArgs): string => vt.labelDisplayedRows(from, to, count);

export const MuiTablePagination = memo(
  ({
    numRows,
    rowsPerPage,
    page,
    onChangePage,
    onChangeRowsPerPage
  }: Props) => {
    const changePageHandler = useCallback(
      (_, newPage: number) => {
        onChangePage(newPage);
      },
      [onChangePage]
    );

    const changeRowsPerPageHandler = useCallback(
      (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newRowsPerPage = stringToNumber(event.target.value);
        if (newRowsPerPage === undefined) return;
        onChangeRowsPerPage(newRowsPerPage);
      },
      [onChangeRowsPerPage]
    );

    return (
      <TablePagination
        component={'div'}
        count={numRows}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        onChangeRowsPerPage={changeRowsPerPageHandler}
        page={page}
        onChangePage={changePageHandler}
        labelRowsPerPage={vt.labelRowsPerPage}
        nextIconButtonProps={nextIconButtonProps}
        backIconButtonProps={backIconButtonProps}
        labelDisplayedRows={labelDisplayedRows}
      />
    );
  }
);

MuiTablePagination.displayName = 'MuiTablePagination';
